'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _components = require('../../components');

var _FossilFuelCompaniesContent = require('./FossilFuelCompaniesContent.css');

var _FossilFuelCompaniesContent2 = _interopRequireDefault(_FossilFuelCompaniesContent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FossilFuelCompaniesContent = (_dec = (0, _reactCssModules2.default)(_FossilFuelCompaniesContent2.default), _dec(_class = function (_Component) {
  (0, _inherits3.default)(FossilFuelCompaniesContent, _Component);

  function FossilFuelCompaniesContent() {
    (0, _classCallCheck3.default)(this, FossilFuelCompaniesContent);
    return (0, _possibleConstructorReturn3.default)(this, (FossilFuelCompaniesContent.__proto__ || (0, _getPrototypeOf2.default)(FossilFuelCompaniesContent)).apply(this, arguments));
  }

  (0, _createClass3.default)(FossilFuelCompaniesContent, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'section',
        { styleName: 'methodology-section' },
        _react2.default.createElement('div', { styleName: 'anchor', id: 'companies' }),
        _react2.default.createElement(
          'h2',
          { styleName: 'section-title' },
          'Fossil fuel companies'
        ),
        _react2.default.createElement(
          'h3',
          { styleName: 'answer-title' },
          'Tracking fossil fuel stocks'
        ),
        _react2.default.createElement(
          'div',
          { styleName: 'answer-info' },
          _react2.default.createElement(
            'p',
            null,
            'Our analysis checks funds for direct stock investments in fossil fuel companies. This list includes several sub-categories: top owners of carbon reserves, coal industry, oil/gas industry, top coal-fired utilities, and fossil-fired utilities.'
          ),
          _react2.default.createElement(
            'p',
            null,
            'Two of these sub-categories are considered ',
            _react2.default.createElement(
              'b',
              null,
              'higher risk'
            ),
            ': top owners of carbon reserves, and top coal-fired utilities. Investment in these companies automatically earns a fund a fossil fuel grade of C or lower.'
          ),
          _react2.default.createElement(_components.ScreenedCompanies, null)
        ),
        _react2.default.createElement(_components.ScrollToTop, null)
      );
    }
  }]);
  return FossilFuelCompaniesContent;
}(_react.Component)) || _class);
exports.default = FossilFuelCompaniesContent;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/FossilFuelCompaniesContent/FossilFuelCompaniesContent.js
// module id = 1379
// module chunks = 0